// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// Import Third Party Libraries
import 'countup.js/dist/countUp.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

// Vantage Add Ons
import './vantage/vantage_utils';

import { library , dom} from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
// Add all icons to the library so you can use it in your page
library.add(fas,far);
dom.watch();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js